module.exports = __webpack_public_path__ + "img/image3.87cc6565.png";